<template>
  <f-form-group
    v-if="field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :label="field_label"
    :hide-label="hideLabel"
    :horizontal="horizontal"
    v-b-tooltip="tooltip"
    class="yesNoNotesFileWidget"
  >
    <b-form-checkbox
      :checked="field_value.val"
      :disabled="is_disabled"
      :label="field_label"
      @input="button_pressed"
      v-bind="field.params"
      v-if="layout == 'checkbox'"
    ></b-form-checkbox>

    <b-form-checkbox
      :checked="field_value.val"
      :disabled="is_disabled"
      :label="field_label"
      @input="button_pressed"
      switch
      v-bind="field.params"
      v-if="layout == 'switch'"
    ></b-form-checkbox>

    <div v-if="layout == 'buttons'">
      <b-button
        :disabled="is_disabled"
        :value="true"
        :variant="yesColor"
        @click="button_pressed(true)"
      >
        <checkbox-outline-icon v-if="field_value.val == true" />
        {{ yesLabel }}
      </b-button>

      <b-button
        :disabled="is_disabled"
        :value="false"
        :variant="noColor"
        @click="button_pressed(false)"
      >
        <checkbox-outline-icon v-if="field_value.val == false" />
        {{ noLabel }}
      </b-button>

      <b-button
        :disabled="is_disabled"
        value="na"
        :variant="naColor"
        @click="button_pressed('na')"
        v-if="field.params.allow_na"
      >
        <checkbox-outline-icon v-if="isNAValue" />
        {{ naLabel }}
      </b-button>
    </div>

    <b-form-radio-group
      :checked="field_value.val"
      :disabled="is_disabled"
      v-if="layout == 'radios'"
    >
      <b-form-radio :value="true" @change="button_pressed(true)">{{
        yesLabel
      }}</b-form-radio>
      <b-form-radio :value="false" @change="button_pressed(false)">{{
        noLabel
      }}</b-form-radio>
      <b-form-radio
        :value="null"
        @change="button_pressed(null)"
        v-if="field.params.allow_na"
        >{{ naLabel }}
      </b-form-radio>
    </b-form-radio-group>

    <b-form-group v-if="show_links">
      <button
        class="btn btn-link"
        :disabled="is_disabled"
        @click="show_text_form()"
      >
        <span v-if="is_text_form_visible">Hide </span
        ><span v-if="!is_text_form_visible">Add </span>Comment
      </button>
      <button
        class="ml-3 btn btn-link"
        :disabled="is_disabled"
        @click="show_file_upload_form()"
      >
        Upload Files
      </button>
    </b-form-group>

    <b-form-group v-if="is_text_form_visible">
      <b-form-textarea
        :label="field_label"
        :value="field_value.comment"
        @input="update_comment"
        :disabled="is_disabled"
        v-bind="field.params"
        v-if="!is_html"
      ></b-form-textarea>
    </b-form-group>

    <b-form-group
      v-if="is_file_upload_form_visible && field_value.files.length > 0"
    >
      <div v-for="(file, index) in field_value.files" :key="index">
        <b-container>
          <b-row>
            <b-col>
              <o-file-upload
                :disabled="is_disabled"
                :file="field_value.files[index]"
                :title="field.name"
                @change="update_files"
                v-bind="field.params"
                hide-delete
              ></o-file-upload>
            </b-col>
            <b-col
              ><b-button
                v-if="field_value.files.length > 0"
                variant="danger"
                :disabled="is_disabled"
                @click="delete_file(index)"
                ><close-icon /></b-button
            ></b-col>
          </b-row>
        </b-container>
      </div>

      <b-button class="mt-2" @click="add_file()">Add File</b-button>
    </b-form-group>

    <b-form-group
      v-if="is_file_upload_form_visible && field_value.files.length == 0"
    >
      <b-container>
        <b-row>
          <b-col>
            <o-file-upload
              :disabled="is_disabled"
              :file="field_value.files[0]"
              :title="field.name"
              @change="update_files"
              v-bind="field.params"
              hide-delete
            ></o-file-upload>
          </b-col>
          <b-col
            ><b-button
              variant="danger"
              @click="delete_file(0)"
              :disabled="is_disabled"
              ><close-icon /></b-button
          ></b-col>
        </b-row>
      </b-container>

      <b-button class="mt-2" @click="add_file()">Add File</b-button>
    </b-form-group>
  </f-form-group>
</template>

<script>
import FormWidgetMixin from "../FormWidgetMixin.js";
import FFormGroup from "../FFormGroup.vue";
import CheckboxOutlineIcon from "vue-material-design-icons/CheckBoxOutline.vue";
import CloseIcon from "vue-material-design-icons/Close.vue";
import OFileUpload from "../../../vue-ocom/filesystem/OFileUpload.vue";
import { isUndefined } from "lodash";
import { setter } from "../setter";

export default {
  name: "YesNoNotesFilesWidget",
  components: { FFormGroup, CheckboxOutlineIcon, OFileUpload, CloseIcon },
  mixins: [FormWidgetMixin],
  data: () => ({
    show_links: false,
    is_text_form_visible: false,
    is_file_upload_form_visible: false,
  }),
  methods: {
    doChange(newValues) {
      if (!this.is_disabled) {
        var updated_value = {
          ...this.default_value,
          ...this.field_value,
          ...newValues,
        };

        this.on_input(updated_value);
      }
    },
    button_pressed: function (value) {
      this.doChange({ val: value });
    },
    show_text_form: function () {
      this.is_text_form_visible = !this.is_text_form_visible;
    },
    show_file_upload_form: function () {
      this.is_file_upload_form_visible = !this.is_file_upload_form_visible;
    },
    update_comment: function (value) {
      this.doChange({ comment: value });
    },
    update_files: function (value) {
      var currentFiles = this.field_value.files;
      currentFiles.push(value); // add the the list
      // remove null
      currentFiles = currentFiles.filter((e) => e);
      this.doChange({ files: currentFiles });
    },
    add_file: function () {
      var new_file = null;
      this.field_value.files.push(new_file);
    },
    delete_file: function (index) {
      var currentFiles = this.field_value.files;
      currentFiles[index] = null;
      currentFiles = currentFiles.filter((_, i) => index !== i);

      this.doChange({ files: currentFiles });
    },
  },
  computed: {
    default_value() {
      return { val: null, comment: "", files: [] };
    },
    layout() {
      return this.field.params.layout || "checkbox";
    },
    yesLabel: function () {
      return this.field.params.yesLabel || "Yes";
    },
    yesColor: function () {
      if (this.field_value.val === true) {
        if (this.field.params.yesColor) {
          return this.field.params.yesColor;
        }

        return "success";
      }

      return "";
    },
    noLabel: function () {
      return this.field.params.noLabel || "No";
    },
    noColor: function () {
      if (this.field_value.val === false) {
        if (this.field.params.noColor) {
          return this.field.params.noColor;
        }

        return "danger";
      }

      return "";
    },
    naLabel: function () {
      return this.field.params.naLabel || "N/A";
    },
    naColor: function () {
      if (this.isNAValue) {
        if (this.field.params.naColor) {
          return this.field.params.naColor;
        }

        return "warning";
      }

      return "";
    },
    isNullValue: function () {
      return this.has_value && this.field_value.val === null;
    },
    isNAValue: function () {
      return this.field_value.val === "na";
    },
    is_html() {
      return this.field.params.layout == "html";
    },
  },
  watch: {
    defaultValue: {
      handler() {
        if (this.item && this.field) {
          setter(this, this.item, this.field.code, this.field.default_value);
        }
      },
      deep: true,
    },
    field_value: {
      handler() {
        if (this.field.default_value) {
          if (this.field_value.val === null) {
            // Set default_value as value if the value has not been set!
            this.field_value = this.field.default_value;
          }
        }

        if (this.field_value && this.field_value.val !== null) {
          this.show_links = true;
        } else {
          this.show_links = false;
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.field_value.val !== null) {
      this.show_links = true;
    }

    if (this.field_value.comment) {
      this.is_text_form_visible = true;
    }

    if (this.field_value.files.length > 0) {
      this.is_file_upload_form_visible = true;
    }
  },
};
</script>

<style>
.yesNoNotesFileWidget {
}
</style>
